export function menu(state) {
    return state.menu;
}
